import type { UserState } from '../../../types/appState';
import type { TRootState } from '../reducers';

export const selectCountryCode = (state: TRootState): string | undefined => {
  return state.user?.countryCode;
};

export const selectProfileImage = (state: TRootState): string | undefined => {
  return state.user?.profileImage;
};

export const selectUserId = (state: TRootState): string | undefined => {
  return state.user?.id;
};

export const selectUserName = (state: TRootState): UserState['name'] | undefined => {
  return state.user?.name;
};

export const selectUser = (state: TRootState): UserState | null => {
  return state.user;
};
